/**
 * 目前eventType 仅支持`click`和`exposure`两种
 */

export default {
  // MARKETING_SCHOLARSHIP_2019
  MARKETING_SCHOLARSHIP_2019_GET_COUPON_CLICK: {
    eventType: 'click',
  },
  MARKETING_SCHOLARSHIP_2019_USE_COUPON_CLICK: {
    eventType: 'click',
  },
  MARKETING_SCHOLARSHIP_2019_COURSE_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_SCHOLARSHIP_2019_COURSE_CLICK: {
    eventType: 'click',
  },
  MARKETING_SCHOLARSHIP_2019_MORE_CLICK: {
    eventType: 'click',
  },
  MARKETING_SCHOLARSHIP_2019_PHONE_CLICK: {
    eventType: 'click',
  },
  MARKETING_SCHOLARSHIP_2019_WECHAT_CLICK: {
    eventType: 'click',
  },
  MARKETING_SCHOLARSHIP_2019_NAV_CLICK: {
    eventType: 'click',
  },

  // MARKETING_LIUXUAN_TEST
  MARKETING_LIUXUAN_TEST_START_CLICK: {
    eventType: 'click',
  },
  MARKETING_LIUXUAN_TEST_FINISH: {
    eventType: 'click',
  },
  MARKETING_LIUXUAN_TEST_RESULT_CLICK: {
    eventType: 'click',
  },
  MARKETING_LIUXUAN_TEST_MORE_CLICK: {
    eventType: 'click',
  },

  // MARKETING_BIRTHDAY
  MARKETING_ANI2019_COURSE_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_ANI2019_COURSE_CLICK: {
    eventType: 'click',
  },
  MARKETING_ANI2019_PROJECT_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_ANI2019_PROJECT_CLICK: {
    eventType: 'click',
  },
  MARKETING_ANI2019_VIP_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_ANI2019_VIP_CLICK: {
    eventType: 'click',
  },
  MARKETING_ANI2019_COMMENT_SEND: {
    eventType: 'click',
  },
  MARKETING_ANI2019_PHONE_CLICK: {
    eventType: 'click',
  },
  MARKETING_ANI2019_WECHAT_CLICK: {
    eventType: 'click',
  },
  MARKETING_ANI2019_APP_DOWNLOAD: {
    eventType: 'click',
  },

  // MARKETING_SPRING_COURSE_2020
  MARKETING_SPRING_COURSE_2020_TABLE_CLICK: {
    eventType: 'click',
  },
  MARKETING_SPRING_COURSE_2020_LIST_CLICK: {
    eventType: 'click',
  },

  // MARKETING_MAY_SPRING_COURSE_2020
  MARKETING_MAY_SPRING_COURSE_2020_TABLE_CLICK: {
    eventType: 'click',
  },
  MARKETING_MAY_SPRING_COURSE_2020_LIST_CLICK: {
    eventType: 'click',
  },


  // MARKETING_VIP_DAY_2020
  MARKETING_VIPDAY_DETAIL_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_DRAW_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_APPLY_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_AUDIO_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_AUDIO_MORE_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_BUY_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_BOTTOM_BUY_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_COURSE_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_COURSE_POPUP_BUTTON_CLICK: {
    eventType: 'click',
  },
  MARKETING_WISHBOTTLE_START_CLICK: {
    eventType: 'click',
  },
  MARKETING_WISHBOTTLE_BOTTLE_CLICK: {
    eventType: 'click',
  },
  MARKETING_WISHBOTTLE_FINISH_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_PARENTS_REMIND_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_PARENTS_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_AUDIO_TRIAL_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_TARINING_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_AUDIO_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_MORE_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_DISCOUNT_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_DISCOUNT_MORE_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_FLOATING_BUY_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_EXLIVE_CLICK: {
    eventType: 'click',
  },

  // 423 世界读书日
  MARKETING_423_TABS_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_COURSE_BUY_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_DRAW_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_BOTTOM_BAR_WECHAT_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_BOTTOM_BAR_BUY_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_LIVE_APPLY: {
    eventType: 'click',
  },

  MARKETING_423_BOOKLIST_POPUP_JOIN_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_BOOKLIST_POPUP_OPEN_CLICK: {
    eventType: 'click',
  },

  MARKETING_423_BOOKLIST_OPEN_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_REMIND_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_REMIND_2_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_REMIND_SHARE_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_DOWNLOAD_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_WECHAT_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_BOTTOM_DETAIL_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_DETAIL_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_EXPERIENCE_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_TRAINING_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_TRIAL_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_TRIAL_MORE_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_PARENT_FM_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_BUY_CLICK: {
    eventType: 'click',
  },

  // 六一活动
  MARKETING_2061_SEKILL_BALL_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_LOTTERY_RECORD_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_LOTTERY_AGAIN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_GOLMUD_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_LIVE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_VIP_INVITE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_VIP_INVITE_RECORD_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_VIP_INVITE_RULE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_APP_DOWNLOAD_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_QA_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_NOTIFY_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_SHARE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2061_VIP_CLICK: {
    eventType: 'click',
  },

  // 6月会员日
  MARKETING_VIPDAY_REMIND_PHONE_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_REMIND_PHONE_REJECT_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_REMIND_COUPON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_GROUP_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_GROUP_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_GROUP_NOTIFY_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_LIVE_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_AUDIO_FREE_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_AUDIO_PLAY_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_AUDIO_FREE_PLAY_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_BOTTOM_BUY_CLICK: {
    eventType: 'click',
  },


  // 618
  MARKETING_20618_EXVIP_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_SECKILL_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_VIP_GROUPBUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_YOUZAN_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_PROJECT_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_LIVE_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_APP_DOWNLOAD_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_WECHAT_CLICK: {
    eventType: 'click',
  },
  MARKETING_20618_PHONE_CLICK: {
    eventType: 'click',
  },

  MARKETING_VIPDAY_COUPON_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_SINGAPORE_CLICK: {
    eventType: 'click',
  },
  MARKETING_VIPDAY_POPUP_BUY_CLICK: {
    eventType: 'click',
  },

  // 学习力测评
  MARKETING_LEARNABILITYTEST_BEGIN_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_START_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_NEXT_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_FINISH_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_RESULT_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_SHARE_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_RETRY_CLICK: {
    eventType: 'click',
  },
  MARKETING_LEARNABILITYTEST_PLAN_CLICK: {
    eventType: 'click',
  },

  // 周年庆 2020 主页
  ANNIVERSARY_2020_MAJOR_BLESSING_PLAY_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_BLESSING_PLAY_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_WRITE_MESSAGE_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_WRITE_MESSAGE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_WRITE_MESSAGE_POPUP_SEND_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_WRITE_MESSAGE_POPUP_LOGIN_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_WRITE_MESSAGE_POPUP_RECEIVE_GIFT_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_RESERVE_LIVE_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_RESERVE_LIVE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_RESERVE_LIVE_QRCODE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_NEW_COURSE_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_NEW_COURSE_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_VIP_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_VIP_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_THEME_PACK_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_THEME_PACK_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_THEME_PACK_SHOW_MORE_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_THEME_PACK_SHOW_MORE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_LIVE_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_LIVE_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_LIVE_SHOW_MORE_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_LIVE_SHOW_MORE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_PROJECT_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_PROJECT_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_ENTITY_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_ENTITY_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_ENTITY_SHOW_MORE_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_ENTITY_SHOW_MORE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_RECEIVE_GIFT_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_MAJOR_RECEIVE_GIFT_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_CONTACT_TEL_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_CONTACT_WECHAT_CLICK: {
    eventType: 'click',
  },

  // 周年庆 2020 学习包
  ANNIVERSARY_2020_BRANCH_THEME_PACK_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_BRANCH_THEME_PACK_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_BRANCH_THEME_PACK_BACK_CLICK: {
    eventType: 'click',
  },

  // 周年庆 2020 直播课
  ANNIVERSARY_2020_BRANCH_LIVE_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_BRANCH_LIVE_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_BRANCH_LIVE_BACK_CLICK: {
    eventType: 'click',
  },

  // 周年庆 2020 实物
  ANNIVERSARY_2020_BRANCH_ENTITY_LIST_EXPOSURE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2020_BRANCH_ENTITY_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_BRANCH_ENTITY_BACK_CLICK: {
    eventType: 'click',
  },

  // 成长报告
  MARKETING_BD2020_START_CLICK: {
    eventType: 'click',
  },
  MARKETING_BD2020_RESULT_CLICK: {
    eventType: 'click',
  },
  MARKETING_BD2020_PLAN_CLICK: {
    eventType: 'click',
  },
  MARKETING_BD2020_COUPON_CLICK: {
    eventType: 'click',
  },
  MARKETING_BD2020_LOGIN: {
    eventType: 'click',
  },
  MARKETING_BD2020_GET_COUPON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2020_MAJOR_COUPON_CLICK: {
    eventType: 'click',
  },

  // 公益活动
  PUBLIC_WELFARE_EXPOSURE: {
    eventType: 'exposure',
  },
  PUBLIC_WELFARE_DOWNLOAD_APP_CLICK: {
    eventType: 'click',
  },
  PUBLIC_WELFARE_JOIN_CLICK: {
    eventType: 'click',
  },
  PUBLIC_WELFARE_SHARE_CLICK: {
    eventType: 'click',
  },
  PUBLIC_WELFARE_LOGIN_EXPOSURE: {
    eventType: 'exposure',
  },
  PUBLIC_WELFARE_LOGIN_CLICK: {
    eventType: 'click',
  },
  PUBLIC_WELFARE_RELAY_MORE_CLICK: {
    eventType: 'click',
  },

  // 读书日活动
  MARKETING_2021READINGDAY_LIVE_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_2021READINGDAY_LIVE_ORDER_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_MILLIONREAD_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_2021READINGDAY_MILLIONREAD_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_CHARITY_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_2021READINGDAY_CHARITY_JOIN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_SECKILL_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_2021READINGDAY_SECKILL_REMIND_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_SECKILL_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_SECKILL_DATE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_GROUPON_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_GROUPON_MORE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_GROUPON_MORE_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_RADIO_LISTEN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_RADIO_MORE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_RADIO_MORE_LISTEN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_RADIO_VIP_BUY_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_PROJECT_JOIN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021READINGDAY_PROJECT_MORE_CLICK: {
    eventType: 'click',
  },

  // 六一活动
  MARKETING_2021CHILDRENDAY_LOTTERY_EXPOSURE: {
    eventType: 'exposure',
  },
  MARKETING_2021CHILDRENDAY_LOTTERY_OPEN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_LOTTERY_SHARE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_LOTTERY_PRIZE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_LOTTERY_MYPRIZE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_PROJECT_JOIN_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_PROJECT_MORE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_COURSE_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_VIP_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021CHILDRENDAY_GROUPON_CLICK: {
    eventType: 'click',
  },

  // 暑期预售
  MARKETING_2021SUMMERPRESALE_ORDER_CLICK: {
    eventType: 'click',
  },
  MARKETING_2021SUMMERPRESALE_MORE_CLICK: {
    eventType: 'click',
  },

  // 八周年庆
  ANNIVERSARY_2021_MESSAGE_BOARD_SHOW_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_MESSAGE_BOARD_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_MESSAGE_WRITING_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_LIVE_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_LIVE_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_MBA_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_MBA_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_LIVING_COURSE_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_LIVING_COURSE_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_VIP_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_VIP_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_PROJECT_ASTRONAUT_PLAN_BOTTUN_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_PROJECT_HARRY_PORTER_WORKSHOP_JANUARY_EIGHTTEN_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_PUPPY_QIANQIAN_GIFT_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_XUXUDUODUO_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_QUALITY_TIMES_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_YOUNG_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_ALL_THINGS_BUTTON_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_THE_WORLD_IS_OUR_CLASS_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ENTITY_YOUNG_MBA_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_BRANCH_ENTITY_LIST_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_ACTIVITY_FIVE_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_ACTIVITY_SIX_EXPOSE: {
    eventType: 'exposure',
  },
  ANNIVERSARY_2021_DOWNLOAD_APP_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_WECHAT_CLICK: {
    eventType: 'click',
  },
  ANNIVERSARY_2021_TELEPHONE_CLICK: {
    eventType: 'click',
  },

};
